import * as history from 'history';

export const browserHistory = history.createBrowserHistory();
